var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExostarLogo = function SvgExostarLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Exostar Logo",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1904.7 274",
    style: {
      enableBackground: "new 0 0 1904.7 274"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7E8083;}\n\t.st1{fill:#EE3524;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_large_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_grey_exostar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    className: "st0",
    d: "M588.5,110.3c9-41.9,33.9-58.3,67.4-58.3s51.4,16.4,42.3,58.3s-33.8,58.3-67.4,58.3 S579.5,152.1,588.5,110.3z M500.9,110.3c-23,106.8,68.9,110.3,118.8,110.3s143.2-3.6,166.2-110.3S717,0,667.1,0 S523.9,3.5,500.8,110.3H500.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    className: "st0",
    d: "M854.9,125.8c-39-6.1-50.7-29.1-44.5-58C821.9,14.5,877.9,0,945.6,0c93,0,126,24,119.5,67.5 h-95.8c2.1-7-1.9-14.4-8.9-16.5h-0.1c-7.9-3.2-16.3-4.6-24.8-4.2c-24.5,0-34.3,6-36.2,14.6c-1.3,5.8,0.6,9.5,8.5,10.7 l95.3,14.6c40.1,6.1,61.7,25.1,54.2,60c-10.7,50.1-57.3,73.9-149.8,73.9c-63.4,0-130.7-8.7-117.9-69.2h99.2 c-1.2,6.9,0.4,11.5,5.6,14.6s14.3,4.3,27.1,4.3c25.8,0,34.2-6.9,36.3-16.8c1.3-6-1.2-12.1-11.9-13.8L854.9,125.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    className: "st0",
    d: "M1153.8,58.7h-76.2l11.1-52.5h234.8l-11.1,52.5h-76.2L1203,214.6h-82.3L1153.8,58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    className: "st0",
    d: "M1421.8,139.8H1372l39.5-70.7h0.6L1421.8,139.8z M1241.7,214.5h87.6l13.9-23.9h85.8l3.7,23.9 h87.6L1475.8,6.1h-101.1L1241.7,214.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    className: "st0",
    d: "M1647.7,58.8h57.2c13.7,0,23.1,3.7,19.8,19.6c-2.8,13.2-11.1,19.6-26.9,19.6h-58.4 L1647.7,58.8z M1532.3,214.8h82.3l13.4-64.3h58.4c15.1,0,18.4,9.3,16,24.8c-3.7,24.2-5.6,33.2-4,39.4h89.9 c-4.3-7.4-6.1-16-5-24.5l6.3-45.7c2.4-18.1-5.3-28.6-16.8-32.1v-0.6c25.4-7,38.1-28,42.2-47.6c4.8-22.8-3.7-42.9-17.6-50.5 c-10.2-5.5-24.1-7.6-47.9-7.6h-173.2L1532.3,214.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-6",
    className: "st0",
    d: "M530.1,7.3h-96.6l-40.9,45.5L371.1,7.3h-96.6l60.3,99.5L222.3,211.7l9.9-46.8H92.9l6-28h129.4 l10.8-50.8H109.8l6-28h139.3l10.8-50.8H44.3L0,215.8h219.6l2.3-1.5l161.4-106.1l-62,106l48.4-52.1l27.1,53.8h101.6L427.8,107 L530.1,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-7",
    className: "st1",
    d: "M339.9,153.5l-173,114.2H273L339.9,153.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-8",
    className: "st0",
    d: "M1867.9,6.1c20.3,0,36.8,16.5,36.8,36.8s-16.5,36.8-36.8,36.8c-20.3,0-36.8-16.5-36.8-36.8 l0,0C1831.2,22.6,1847.6,6.2,1867.9,6.1z M1867.9,74.1c16.9,0,29.6-13.6,29.6-31.3s-12.7-31.3-29.6-31.3 c-16.5,0.2-29.8,13.7-29.6,30.3c0,0,0,0,0,0v1c-0.7,16.5,12.1,30.4,28.6,31.2L1867.9,74.1L1867.9,74.1z M1853.9,21.4h16.5 c9.9,0,14.7,3.8,14.7,12.1c0.5,6-4,11.4-10,11.9h-1.1l12.2,19.1h-7.4l-12-19.1h-5.9v19.1h-7L1853.9,21.4z M1860.9,39.9h8.3 c5.4,0,8.9-1.1,8.9-6.7c0-4.9-4.4-6.3-8.9-6.3h-8.3V39.9z"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExostarLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "exostar-logo.c8a14a246ebe7d18625dba767b884fd6.svg";